export enum TicketSourcePlatform {
  PAGE = "facebook",
  INSTAGRAM = "instagram",
  WHATSAPP = "whatsapp",
}
